import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { makeStyles } from "tss-react/mui";
import { pxToRem } from "@/util";
import { AppColors } from "@/assets/colors";
import { useRouter, useSearchParams } from "next/navigation";
import Sortcont from "./sortcont";
import { useDispatch } from "react-redux";
import { resetFilter } from "@/store/propertyfilter";

interface TabPanelProps {
  children?: React.ReactNode;
  index: string;
  value: string;
}

enum propType {
  LISTING = "LISTINGS",
  INVESTMENT = "INVESTMENTS",
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: string) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const searchParams = useSearchParams();
  const currentPage = searchParams.get("type");
  const router = useRouter();
  const dispatch = useDispatch();

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    dispatch(resetFilter());
    router.push(`?type=${newValue}`);
  };

  const { classes } = styles();

  return (
    <Box sx={{ width: "100%" }}>
      <Box>
        <Tabs
          value={currentPage}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            "& .MuiTabs-indicator": {
              display: "none",
            },
          }}
          style={{ border: "1px solid red", display: "none" }} // This line removes the Tab now so later we can just remove this line and it works {max}
        >
          <Tab
            label="Our Listings"
            value={propType.LISTING} // ADD THIS LINE
            {...a11yProps(propType.LISTING)}
            sx={{
              backgroundColor:
                currentPage === propType.LISTING
                  ? AppColors.neutral["90"]
                  : "transparent",
              color:
                currentPage === propType.LISTING
                  ? "#fff"
                  : AppColors.text.default,
              ...tabStyle,
            }}
          />
          <Tab
            label="Investment Offers"
            value={propType.INVESTMENT} // ADD THIS LINE
            {...a11yProps(propType.INVESTMENT)}
            sx={{
              backgroundColor:
                currentPage === propType.INVESTMENT
                  ? AppColors.neutral["90"]
                  : "transparent",
              color:
                currentPage === propType.INVESTMENT
                  ? "#fff"
                  : AppColors.text.default,
              ...tabStyle,
            }}
          />
        </Tabs>
      </Box>
      <Box className={classes.sub} sx={{ boxShadow: 6 }}>
        <CustomTabPanel value={currentPage ?? ""} index={propType.LISTING}>
          <Sortcont currentPage={propType.LISTING || ""} />
        </CustomTabPanel>
        <CustomTabPanel value={currentPage ?? ""} index={propType.INVESTMENT}>
          <Sortcont currentPage={propType.INVESTMENT || ""} />
        </CustomTabPanel>
      </Box>
    </Box>
  );
}

const tabStyle = {
  borderTopLeftRadius: pxToRem(8),
  borderTopRightRadius: pxToRem(8),
  padding: pxToRem(12),
  transition: "background-color 0.3s ease",
  fontSize: pxToRem(16), // Adjust font size
  fontWeight: 500, // Make it bold
  letterSpacing: "0.5px", // Improve text spacing
  textTransform: "capitalize", // Optional: Change casing
};

const styles = makeStyles()((theme) => ({
  tabCont: {},
  sub: {
    flex: 1,
    height: "72%",
    width: "87%",
    borderTopRightRadius: pxToRem(8),
    borderBottomRightRadius: pxToRem(8),
    borderBottomLeftRadius: pxToRem(8),
    backgroundColor: AppColors.neutral["90"],
    marginTop: pxToRem(50), // This is the space between the tab and the content remove when you uncomment the tab style{max}
    [theme.breakpoints.down(1360)]: {
      width: "93%",
    },
  },
  search: {
    fontWeight: 400,
    fontSize: pxToRem(16),
    color: AppColors.text.second,
  },

  selectName: {
    fontSize: pxToRem(20),
    fontWeight: 500,
    color: AppColors.text.default,
    [theme.breakpoints.down(1360)]: {
      fontSize: pxToRem(18),
      fontWeight: 400,
    },
  },
  divider: {
    height: pxToRem(40),
    borderWidth: 1.7,
    borderStyle: "solid",
    borderColor: AppColors.neutral[85],
  },
  dropCont: {
    display: "flex",
    flexDirection: "row",
    gap: pxToRem(10),
    alignItems: "flex-end",
    justifyContent: "space-between",
  },
  drop: {
    display: "grid",
    gridTemplateColumns: "repeat(6,1fr)",
    gap: theme.spacing(4),
    [theme.breakpoints.down(1360)]: {
      gap: theme.spacing(2),
    },
  },
  btn: {
    height: pxToRem(46),
    borderRadius: pxToRem(8),
    width: pxToRem(150),
    alignSelf: "end",
    justifySelf: "end",
    [theme.breakpoints.down(1360)]: {
      width: pxToRem(100),
    },
  },
  sort: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    // padding: theme.spacing(3), //Remove this padding when you uncomment the tab style {max}
    [theme.breakpoints.down(1360)]: {
      padding: theme.spacing(0), //cross check this padding
    },
  },
}));
